import { TokenBalance } from "@typings/tokenBalance"

export const getTokenBalances = async (
  authToken: string
): Promise<TokenBalance[]> => {
  try {
    const response = await fetch(
      `${import.meta.env.VITE_CORE_API_URL}/users/balances`,
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      }
    )

    if (!response.ok)
      throw new Error(`Error: ${response.status} ${response.statusText}`)

    const data = await response.json()

    const tokens: TokenBalance[] = data.data
    return tokens
  } catch (error) {
    console.error("Failed to fetch tokens:", error)
    throw error
  }
}
